module.exports = __webpack_public_path__ + "static/media/treasures__icon1.ae6102e3.svg";